import { render, staticRenderFns } from "./PolicyDocumentUpload.vue?vue&type=template&id=6afbfe2d&"
import script from "./PolicyDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports